export default __webpack_public_path__ + "static/media/logo_polisport_black.20925785.png";